//  store.js 中都mutation中增加添加和删除token的方法
import Vue from 'vue'
import Vuex from 'vuex'
import { setItem, getItem, removeItem } from '@/utils/storage.js'
Vue.use(Vuex)

// const key = 'token';
const state = { // 全局管理的数据存储
    isLogin: '0',
    ser: null,
    token: getItem('token') ? getItem('token') : '', // token
    // token: ''
};
export default new Vuex.Store({
    state,
    mutations: {
        $_setToken(state, value) { // 设置存储token
            state.token = value;
            setItem('token', value);
            setItem('isLogin', 1);
        },
        $_removeStorage() { // 删除token
            removeItem('token');
        },
    }
})